export function useDateUtils() {
	// Helper functions for consistent date/time formatting
	function formatDateForInput(date) {
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, "0");
		const day = String(date.getDate()).padStart(2, "0");
		return `${year}-${month}-${day}`;
	}

	function formatTimeForInput(date) {
		const hours = String(date.getHours()).padStart(2, "0");
		const minutes = String(date.getMinutes()).padStart(2, "0");
		return `${hours}:${minutes}`;
	}

	function formatDateTimeForDisplay(date) {
		return new Intl.DateTimeFormat("de-DE", {
			weekday: "long",
			year: "numeric",
			month: "long",
			day: "numeric",
			hour: "2-digit",
			minute: "2-digit",
		}).format(date);
	}

	function formatDateForDisplay(date) {
		return new Intl.DateTimeFormat("de-DE", {
			weekday: "long",
			year: "numeric",
			month: "long",
			day: "numeric",
		}).format(date);
	}

	function formatTimeForDisplay(date) {
		return new Intl.DateTimeFormat("de-DE", {
			hour: "2-digit",
			minute: "2-digit",
		}).format(date);
	}

	function parseFormDateTime(dateStr, timeStr) {
		return new Date(`${dateStr}T${timeStr}`);
	}

	function validateDateRange(startDate, startTime, endDate, endTime) {
		const startDateTime = parseFormDateTime(startDate, startTime);
		const endDateTime = parseFormDateTime(endDate, endTime);

		const errors = {};

		if (startDateTime >= endDateTime) {
			errors.endDate = "Endzeit muss nach der Startzeit liegen";
		}

		// Minimum duration validation (15 minutes)
		const duration = endDateTime - startDateTime;
		const minDuration = 15 * 60 * 1000; // 15 minutes

		if (duration < minDuration) {
			errors.endTime = "Buchung muss mindestens 15 Minuten lang sein";
		}

		return {
			isValid: Object.keys(errors).length === 0,
			errors,
			startDateTime,
			endDateTime,
			duration,
		};
	}

	function getDurationText(startDateTime, endDateTime) {
		const duration = endDateTime - startDateTime;
		const hours = Math.floor(duration / (1000 * 60 * 60));
		const minutes = Math.floor((duration % (1000 * 60 * 60)) / (1000 * 60));

		if (hours > 0) {
			return `${hours}h ${minutes}min`;
		}
		return `${minutes}min`;
	}

	return {
		formatDateForInput,
		formatTimeForInput,
		formatDateTimeForDisplay,
		formatDateForDisplay,
		formatTimeForDisplay,
		parseFormDateTime,
		validateDateRange,
		getDurationText,
	};
}
